module.exports = __webpack_public_path__ + "img/banrisul.37283254.svg";